import _Guide from './Guide';
import './style';

export type { GuideProps } from './Guide';
export * from './type';

export const Guide = _Guide;

export default Guide;
